import { _ep0, _mw0, command } from "../commandBuilder";
import { DeleteRegistration$ } from "../schemas/schemas_0";
export class DeleteRegistrationCommand extends command(_ep0, _mw0, "DeleteRegistration", DeleteRegistration$) {
}
